export const claimsSelector = ({ login }) => login.claims;
export const loggedInSelector = ({ login }) => login.loggedIn;
export const loggingInSelector = ({ login }) => login.loggingIn;
export const userSelector = ({ login }) => login.user;